import { APPS } from '@/features/core/container';
import { GroupRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import icon from '../assets/app-info.svg?vue';

export const APP_HELP_V2 = GroupRole.APP_HELP_V2;

export default option(APPS, async () => {
  return {
    name: APP_HELP_V2,
    label: 'Help v2',
    link: {
      to: { name: 'AppHelpV2' },
      icon,
      class: '',
    },
    order: Number.POSITIVE_INFINITY,
  };
});
